import { defineMessages } from 'react-intl'

const scope = `procurify.expense.featureSet.ExpenseRequestView`

export default defineMessages({
  draftSavedTitle: {
    id: `${scope}.draftSavedTitle`,
    defaultMessage: 'Expense request draft saved',
  },
  submitSuccessTitle: {
    id: `${scope}.submitSuccessTitle`,
    defaultMessage: 'Expense request submitted',
  },
  resetSuccessTitle: {
    id: `${scope}.resetSuccessTitle`,
    defaultMessage: 'Expense request reset',
  },
  emptyItemsErrorTitle: {
    id: `${scope}.emptyItemsErrorTitle`,
    defaultMessage: 'Info',
  },
  resetButton: {
    id: `${scope}.resetButton`,
    defaultMessage: 'Reset form',
  },
  saveDraftButton: {
    id: `${scope}.saveDraftButton`,
    defaultMessage: 'Save draft',
  },
  submitButton: {
    id: `${scope}.submitButton`,
    defaultMessage: 'Submit',
  },
  overBudgetConfirmHeader: {
    id: `${scope}.overBudgetConfirmHeader`,
    defaultMessage: 'Over budget',
  },
  overBudgetConfirmMessage: {
    id: `${scope}.overBudgetConfirmMessage`,
    defaultMessage:
      'There is insufficient budget to self-approve this expense. Do you want to self-approve anyways?',
  },
  overBudgetConfirmButton: {
    id: `${scope}.overBudgetConfirmButton`,
    defaultMessage: 'Confirm',
  },
  overBudgetCancelButton: {
    id: `${scope}.overBudgetCancelButton`,
    defaultMessage: 'Cancel',
  },
  emptyItemsError: {
    id: `${scope}.emptyItemsError`,
    defaultMessage: 'Please add at least one expense item',
  },
})
